import { Box } from "@material-ui/core";
import dayjs from "dayjs";
import * as React from "react";
import { useHistory } from "react-router";
import { useRecoilCallback, useRecoilValue } from "recoil";

import { AccordionDetailItemRow } from "@/components/management/AccordionDetailItemRow";
import { DetailSection, useDetailStyles } from "@/components/management/DetailSection";
import { PropertyEditPageState } from "@/view_models/atoms";
import { SelectedProperty } from "@/view_models/propertySelectors";

// 検討中物件詳細　物件情報
export const ManagementConsiderationDetailPropertyInfo: React.FC = () => {
  const classes = useDetailStyles();
  const history = useHistory();
  const property = useRecoilValue(SelectedProperty);

  // useRecoilCallbackを使用して非同期の状態更新を行う
  const updatePropertyEditPageState = useRecoilCallback(({ snapshot, set }) => async (newState) => {
    set(PropertyEditPageState, newState);
    // 状態が更新されるのを待つ
    await snapshot.getPromise(PropertyEditPageState);
  });

  // 物件詳細情報編集ボタンクリック時
  const onClickEditProrpertyInfo = async () => {
    await updatePropertyEditPageState("property_info");
    history.push("/edit_property");
  };

  return (
    <>
      <DetailSection title="基本情報" onEdit={onClickEditProrpertyInfo}>
        <Box className={classes.rows}>
          {/* 物件情報 */}
          {property.property.name && (
            <AccordionDetailItemRow v2 title="マンション・アパート名" value={property.property.name} />
          )}
          {property.property.unit_detail.room_number && (
            <AccordionDetailItemRow v2 title="号室" value={property.property.unit_detail.room_number} />
          )}
          {property.property.unit_detail.floor && (
            <AccordionDetailItemRow v2 title="所在階" value={`${property.property.unit_detail.floor}階`} />
          )}
          {property.property.prefecture && (
            <AccordionDetailItemRow v2 title="都道府県" value={property.property.prefecture} />
          )}
          {property.property.city && <AccordionDetailItemRow v2 title="市区町村" value={property.property.city} />}
          {property.property.town && <AccordionDetailItemRow v2 title="番地" value={property.property.town} />}
          {property.property.railway && <AccordionDetailItemRow v2 title="路線名" value={property.property.railway} />}
          {property.property.station && <AccordionDetailItemRow v2 title="駅名" value={property.property.station} />}
          {property.property.walk && <AccordionDetailItemRow v2 title="駅徒歩" value={`${property.property.walk}分`} />}
          {property.property.built_at && (
            <AccordionDetailItemRow
              v2
              title="築年"
              value={`${dayjs().year() - dayjs(property.property.built_at).year()}年`}
            />
          )}
          {property.property.unit_detail.occupied_area_m2 && (
            <AccordionDetailItemRow v2 title="占有面積" value={`${property.property.unit_detail.occupied_area_m2}㎡`} />
          )}
          {property.property.unit_detail.layout && (
            <AccordionDetailItemRow v2 title="間取り" value={property.property.unit_detail.layout} />
          )}
          {property.property.structure && (
            <AccordionDetailItemRow v2 title="構造" value={property.property.structure} />
          )}
          {property.property.rental_management_company && (
            <AccordionDetailItemRow v2 title="管理形態" value={property.property.rental_management_company} />
          )}
        </Box>
      </DetailSection>
    </>
  );
};
